export default {
    username:'Username',
    name:'name',
    lastname:'Lastname',
    status:'Status',
    actions:'Actions',
    image:'Image',
    addNewDoctor:'Add new doctor',
    of:'Of'
}